// Environment variables
export const APP_URL = import.meta.env.VITE_APP_URL;
export const AWS_REGION = import.meta.env.VITE_AWS_REGION;
export const AWS_COGNITO_CLIENT_ID = import.meta.env.VITE_AWS_COGNITO_CLIENT_ID;
export const AWS_COGNITO_USER_POOL_ID = import.meta.env.VITE_AWS_COGNITO_USER_POOL_ID;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const AWS_COGNITO_DOMAIN = import.meta.env.VITE_AWS_COGNITO_DOMAIN;
export const AWS_FEDERATED_LOGIN_REDIRECT_URI = import.meta.env.VITE_AWS_FEDERATED_LOGIN_REDIRECT_URI || `${APP_URL}/callback`;
export const OTP_RESEND_INTERVAL = Number(import.meta.env.VITE_OTP_RESEND_INTERVAL) || 300; // Default to 5 minutes if not set
export const OTP_EXPIRATION_TIME = Number(import.meta.env.VITE_OTP_EXPIRATION_TIME) || 600; // Default to 1 minute for testing
export const ENV = import.meta.env.VITE_ENV || 'dev'; // Default to 'dev' if not set

export const APP_ACCESS_TOKEN_KEY = 'awsAccessToken';
export const AWS_ACCESS_TOKEN_KEY = 'accessToken';
export const AWS_REFRESH_TOKEN_KEY = 'refreshToken';
export const AWS_COGNITO_MFA_ACCESS_TOKEN_KEY = 'awsCognitoMfaAccessToken';
export const AWS_FEDERATED_ACCESS_TOKEN_KEY = 'awsFederatedAccessToken';
export const AWS_USER_ID_TOKEN_KEY = 'id';
export const USER_EMAIL_KEY = 'email';
export const FULL_NAME_KEY = 'fullName';
export const FIRST_NAME_KEY = 'firstName';
export const LAST_NAME_KEY = 'lastName';
export const ROLE_KEY = 'role';
export const TIER_KEY = 'tier';
export const AWS_REGISTER_SESSION_TOKEN_KEY = 'registerToken';
export const OTP_RESEND_KEY = 'otp-resend-start';
export const OTP_TIMESTAMP_KEY = 'otp-timestamp';
export const REGISTRATION_STEPS_KEY = 'profile-setup-step';
export const MEMBER_REGISTRATION_STEPS_KEY = 'member-profile-setup-step';
export const PKCE_CODE_VERIFIER_KEY = 'pkce-code-verifier';
